import { render, staticRenderFns } from "./PointManagmentDashboard.vue?vue&type=template&id=e9f09daa&scoped=true"
import script from "./PointManagmentDashboard.vue?vue&type=script&lang=js"
export * from "./PointManagmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./PointManagmentDashboard.vue?vue&type=style&index=0&id=e9f09daa&prod&scoped=true&lang=css"
import style1 from "./PointManagmentDashboard.vue?vue&type=style&index=1&id=e9f09daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f09daa",
  null
  
)

export default component.exports